import React, { ReactElement } from 'react';
import { Headline } from '..';

export default function FeatureGridHeader(): ReactElement {
  return (
    <section className="relative mt-16 flex justify-center p-4 max-[990px]:[&_.headline]:relative max-[990px]:[&_img]:hidden max-[990px]:[&_svg]:hidden">
      <Headline level="1" color="blue" className="absolute z-10 text-center">
        Come for the features,
        <br />
        stay for the magic
      </Headline>
      <img
        src="/homepage__features-magic-sparkle.svg"
        alt=""
        role="presentation"
        className="h-19.25 w-15 translate-x-120 -translate-y-4"
      />

      <svg
        width="365"
        height="59"
        viewBox="0 0 365 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="translate-x-8.5 translate-y-15.5">
        <path
          d="M0.5 58.8569L2.19636 6.40476L364.5 0.856934L362.942 58.8569H0.5Z"
          fill="var(--color-base-pink)"
        />
      </svg>
    </section>
  );
}
